import React, { Component } from 'react';

import { func, arrayOf, shape, bool } from 'prop-types';
import { connect } from 'react-redux';
import { withState } from 'recompose';
import { bindActionCreators } from 'redux';

import * as userActions from 'actions/user';
import FeatureOnboardingModal from 'components/Common/FeatureOnboardingModal';
import HowToUseThisFeatureButton from 'containers/FeatureOnboarding/HowToUseThisFeatureButton';
import getCurrentFeature from 'containers/FeatureOnboarding/utils/getCurrentFeature';
import withRouter from 'containers/withRouter';

import withUserType from 'containers/withUserType';
import { RouterPropTypes } from 'propTypes/RouterPropTypes';

// Exact routes to block
const FEATURE_ONBOARDING_DENYLIST_EXACT_ROUTES = [
  '/college-applications',
  '/college-applications/applications/submission',
];

// Routes that have a partial match
const FEATURE_ONBOARDING_DENYLIST_ROUTES = [
  '/college-applications/app',
  '/college-applications/casefile',
];

@connect(
  ({ user: { featureOnboarding, featureOnboardingModalOpen } }) => ({
    featureOnboarding,
    featureOnboardingModalOpen,
  }),
  dispatch => bindActionCreators({ ...userActions }, dispatch),
)
@withUserType
@withRouter
@withState('videoComplete', 'setVideoComplete', false)
@withState('justWatchedVideo', 'setJustWatchedVideo', false)
export default class FeatureOnboarding extends Component {
  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    const userLoggedIn = user?.isLoggedIn;
    if (userLoggedIn && userLoggedIn !== prevProps?.user?.isLoggedIn) {
      this.loadData();
    }
  }

  loadData = async () => {
    const {
      retrieveFeatureOnboarding,
      user: { isLoggedIn },
    } = this.props;
    if (isLoggedIn) {
      await retrieveFeatureOnboarding();
    }
  };

  /**
   * Function used to show/hide Feature button in bottom right corner. If true,
   * hides the button. Routes are defined above at
   * FEATURE_ONBOARDING_DENYLIST_EXACT_ROUTES and
   * FEATURE_ONBOARDING_DENYLIST_ROUTES
   * @returns {boolean}
   */
  hideFeatureOnboarding() {
    const {
      router: { location },
    } = this.props;
    const hasDeniedRoute = FEATURE_ONBOARDING_DENYLIST_ROUTES.some(route =>
      location.pathname.includes(route),
    );
    if (
      hasDeniedRoute ||
      FEATURE_ONBOARDING_DENYLIST_EXACT_ROUTES.includes(location.pathname)
    ) {
      return true;
    }
    return false;
  }

  render() {
    const {
      featureOnboardingModalOpen,
      completeFeatureOnboarding,
      featureOnboarding,
      setVideoComplete,
      videoComplete,
      setFeatureOnboardingModalOpen,
      user,
      router: { location },
      justWatchedVideo,
      setJustWatchedVideo,
    } = this.props;

    // use === instead of includes to avoid feUrl is partial path:
    // pathname = /student-list/analytics
    // feUrl = /analytics
    // here currentFeature will match by mistake since string includes is not appropriate
    const currentFeature = getCurrentFeature({ featureOnboarding, location });

    const moduleHasFeatureOnboarding = !!Object.keys(currentFeature).length;

    if (this.hideFeatureOnboarding()) {
      return null;
    }

    return (
      <>
        <HowToUseThisFeatureButton
          buttonLabel={currentFeature.buttonLabel}
          featureOnboardingModalOpen={featureOnboardingModalOpen}
          moduleHasFeatureOnboarding={moduleHasFeatureOnboarding}
          setFeatureOnboardingModalOpen={setFeatureOnboardingModalOpen}
        />
        <FeatureOnboardingModal
          open={
            featureOnboardingModalOpen ||
            (!location.pathname.includes('/college-applications') &&
              moduleHasFeatureOnboarding &&
              (!currentFeature?.completed || justWatchedVideo))
          }
          onClose={() => setFeatureOnboardingModalOpen(false)}
          feature={currentFeature}
          completeFeatureOnboarding={completeFeatureOnboarding}
          setVideoComplete={setVideoComplete}
          videoComplete={videoComplete}
          rewatching={currentFeature?.completed}
          user={user}
          setJustWatchedVideo={setJustWatchedVideo}
        />
      </>
    );
  }
}

FeatureOnboarding.propTypes = {
  retrieveFeatureOnboarding: func.isRequired,
  featureOnboarding: arrayOf(shape({})).isRequired,
  completeFeatureOnboarding: func.isRequired,
  setFeatureOnboardingModalOpen: func.isRequired,
  featureOnboardingModalOpen: bool.isRequired,
  videoComplete: bool.isRequired,
  setVideoComplete: func.isRequired,
  user: shape({}).isRequired,
  setJustWatchedVideo: func.isRequired,
  justWatchedVideo: bool.isRequired,
  router: RouterPropTypes.isRequired,
};
